<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { shouldBeUrl } from 'shared/helpers/Validators';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      accountIdentifier: '',
      clientId: '',
      clientSecret: '',
      baseUrl: 'https://api.avito.ru',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    accountIdentifier: { required },
    clientId: { required },
    clientSecret: { required },
    baseUrl: { required, shouldBeUrl },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const avitoChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'avito',
              account_identifier: this.accountIdentifier?.trim(),
              provider_config: {
                client_id: this.clientId?.trim(),
                client_secret: this.clientSecret?.trim(),
                base_url: this.baseUrl?.trim(),
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: avitoChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.AVITO.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <p class="mb-6 text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.AVITO.DESCRIPTION') }}
    </p>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.accountIdentifier.$error }">
        {{ $t('INBOX_MGMT.ADD.AVITO.ACCOUNT_IDENTIFIER.LABEL') }}
        <input
          v-model="accountIdentifier"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.AVITO.ACCOUNT_IDENTIFIER.PLACEHOLDER')
          "
          @blur="v$.accountIdentifier.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.clientId.$error }">
        {{ $t('INBOX_MGMT.ADD.AVITO.CLIENT_ID.LABEL') }}
        <input
          v-model="clientId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.AVITO.CLIENT_ID.PLACEHOLDER')"
          @blur="v$.clientId.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.clientSecret.$error }">
        {{ $t('INBOX_MGMT.ADD.AVITO.CLIENT_SECRET.LABEL') }}
        <input
          v-model="clientSecret"
          type="password"
          :placeholder="
            $t('INBOX_MGMT.ADD.AVITO.CLIENT_SECRET.PLACEHOLDER')
          "
          @blur="v$.clientSecret.$touch"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.baseUrl.$error }">
        {{ $t('INBOX_MGMT.ADD.AVITO.BASE_URL.LABEL') }}
        <input
          v-model="baseUrl"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.AVITO.BASE_URL.PLACEHOLDER')"
          @blur="v$.baseUrl.$touch"
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.AVITO.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
